const RouterConstants = {
  schemaForLandingPage: [
    {
      '@context': 'http://schema.org',
      '@type': 'organisation',
      name: 'Enterpret - Grok your customer’s feedback',
      description:
        'Enterpret will aggregate your customer feedback across all channels in one place. Our Machine Learning models can adjust to reviews/social media/conversations in over 50+ languages.',
      url: 'https://www.enterpret.com',
      logo: 'https://cdn.enterpret.com/assets/logo/enterpret_logo.png',
      email: 'hello@enterpret.com',
      sameAs: [
        'https://www.facebook.com/enterpret/',
        'https://twitter.com/enterpret_ai',
        'https://www.instagram.com/enterpret/',
      ],
    },
    {
      '@context': 'http://schema.org',
      '@type': 'Webpage',
      name: 'Enterpret - Grok your customer’s feedback',
      description:
        'Enterpret will aggregate your customer feedback across all channels in one place. Our Machine Learning models can adjust to reviews/social media/conversations in over 50+ languages.',
      specialty:
        'Customer Feedback, Aggregated, Analysed, Shared real time, AI powered metrics, Feedback analysis, client feedbacks, Machine Learning models',
      publisher: {
        '@context': 'http://schema.org',
        '@type': 'organisation',
        name: 'Enterpret - Grok your customer’s feedback',
        description:
          'Enterpret will aggregate your customer feedback across all channels in one place. Our Machine Learning models can adjust to reviews/social media/conversations in over 50+ languages.',
        url: 'https://www.enterpret.com',
        logo: 'https://cdn.enterpret.com/assets/logo/enterpret_logo.png',
        email: 'hello@enterpret.com',
        sameAs: [
          'https://www.facebook.com/enterpret/',
          'https://twitter.com/enterpret_ai',
          'https://www.instagram.com/enterpret/',
        ],
      },
    },
    {
      '@context': 'http://schema.org',
      '@type': 'WebSite',
      '@id': 'https://www.enterpret.com/#website',
      url: 'https://www.enterpret.com',
      name: 'Enterpret - Grok your customer’s feedback',
      inLanguage: 'en-US',
      keywords: [
        'online experiences',
        'Customer Feedback, Aggregated, Analysed, Shared real time, AI powered metrics, Feedback analysis, client feedbacks, Machine Learning models',
      ],
      hasPart: [
        {
          '@context': 'http://schema.org/',
          '@type': 'WPHeader',
          '@id': 'https://www.enterpret.com/#header',
          potentialAction: [
            {
              '@type': 'Action',
              name: 'Login',
              target: 'https://www.enterpret.com/login/',
            },
            {
              '@type': 'Action',
              name: 'Request Demo',
              target: 'https://www.enterpret.com/request-demo',
            },
          ],
        },
      ],
    },
  ],
  settingsPath: [
    {
      title: 'Inbounds',
      key: 'integrations',
    },
    {
      title: 'Outbounds',
      key: 'outbounds',
    },
    // {
    //   title: 'Organisation',
    //   key: 'organisation',
    // },
    // {
    //   name: 'Members',
    //   path: 'members',
    // },
    // {
    //   name: 'Plans',
    //   path: 'plans',
    // },
    // {
    //   name: 'Billing',
    //   path: 'billing',
    // },
    // {
    //   name: 'Personal',
    //   path: 'personal',
    // },
  ],
};

export default RouterConstants;
